import type { ReactNode } from 'react';

interface DetailsAccordionItemProps {
    title: string;
    children: ReactNode;
}

function AccordionIcon() {
    return (
        <span className="bg-muted text-muted-foreground border-border ml-4 flex h-8 w-8 shrink-0 items-center justify-center rounded-full border transition-transform duration-200 group-open:rotate-180">
            <svg viewBox="0 0 20 20" className="h-4 w-4" aria-hidden="true">
                <path d="M5 7.5L10 12.5L15 7.5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </span>
    );
}

export default function DetailsAccordionItem({ title, children }: DetailsAccordionItemProps) {
    return (
        <details className="group bg-card border-border overflow-hidden rounded-2xl border shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-emerald-500/20 hover:shadow-md">
            <summary className="flex cursor-pointer list-none items-center justify-between px-6 py-5 select-none focus:outline-none">
                <span className="text-foreground text-sm font-bold md:text-base">{title}</span>
                <AccordionIcon />
            </summary>
            <div className="border-border/60 text-muted-foreground bg-card border-t px-6 pt-5 pb-6 text-sm leading-relaxed md:text-base">{children}</div>
        </details>
    );
}
